import * as S from './TabNavigation.styled';

import useTranslate from 'hooks/useTranslate';

export type FinancialsTab = 'client-invoices' | 'my-billing' | 'service-provider-billing';

interface TabNavigationProps {
    activeTab: FinancialsTab;
    onTabChange: (tab: FinancialsTab) => void;
    isLawFirm?: boolean; // Only show My Aliro Billing tab for law firms
    isSuperSuperAdmin?: boolean;
}

export default function TabNavigation({
    activeTab,
    onTabChange,
    isLawFirm = false,
    isSuperSuperAdmin = false,
}: TabNavigationProps) {
    const { translate } = useTranslate();

    return (
        <S.TabContainer>
            <S.Tab
                active={activeTab === 'client-invoices'}
                onClick={() => onTabChange('client-invoices')}
            >
                Client Invoices
            </S.Tab>
            {isLawFirm && (
                <S.Tab
                    active={activeTab === 'my-billing'}
                    onClick={() => onTabChange('my-billing')}
                >
                    My Aliro Billing
                </S.Tab>
            )}
            {isSuperSuperAdmin && (
                <S.Tab
                    active={activeTab === 'service-provider-billing'}
                    onClick={() => onTabChange('service-provider-billing')}
                >
                    {translate('serviceProviderBilling.tab')}
                </S.Tab>
            )}
        </S.TabContainer>
    );
}
